export type LandingPageEntry = {
  slug: string;
  path: string;
  label: string;
  regionKey: "westCoast" | "eastCoast";
  tag: string;
};

export const landingPages: LandingPageEntry[] = [
  {
    slug: "us-west-coast",
    path: "/r/us-west-coast",
    label: "US West Coast",
    regionKey: "westCoast",
    tag: "west coast",
  },
  {
    slug: "us-east-coast",
    path: "/r/us-east-coast",
    label: "US East Coast",
    regionKey: "eastCoast",
    tag: "east coast",
  },
];
